import ServiceNavigation from './service-navigation';
import ServiceNavigationExpandBottomBehaviour from './expand-bottom-behaviour';
import ServiceNavigationExpandTopBehaviour from './expand-top-behaviour';

const ServiceNavigationBehaviours = {
    expandBottom: ServiceNavigationExpandBottomBehaviour,
    expandTop: ServiceNavigationExpandTopBehaviour,
};

export {
    ServiceNavigation,
    ServiceNavigationBehaviours,
};
